import { gql } from '@apollo/client'

export const gpsrPartyInfo = gql`
  fragment gpsrPartyInfo on GpsrParty {
    type
    name
    address
    postal_code
    city
    province
    country
    phone_number
    website
    email_address
  }
`
